import type { IconData } from '@stacksjs/iconify-core'

export const flash1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M34.336 6.681c.314-1.727-.92-3.34-2.673-3.441c-3.633-.21-9.808-.423-15.875.02a3.78 3.78 0 0 0-3.252 2.426c-3.058 8.035-4.517 15.457-5.137 19.385c-.256 1.62.91 3.063 2.546 3.176c2.438.167 6.2.341 10.555.253c-.452 3.222-.937 8.17-1.42 13.617c-.244 2.75 2.99 4.266 4.874 2.248c7.44-7.973 14.274-16.854 18.03-21.926c1.367-1.848.171-4.359-2.127-4.419A179 179 0 0 0 32 18c.867-3.477 1.635-7.463 2.336-11.319Z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default flash1
